import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SectionHeader from '../../../components/Basic/SectionHeader';
import TextBox from '../../../components/Basic/TextBox';
import FortisButton from '../../../components/Basic/FortisButton';
import CheckBox from '../../../components/Basic/CheckBox';
import util from '../../../lib/util';
import { browserHistory } from 'react-router';
import Panel from 'react-bootstrap/lib/Panel';
// import { relative } from 'path';

class Login extends React.Component {
    constructor(props) {
        super(props);
        props.initAPI({ user: this.props.user });
        this.state = { isShowPassword: true, isLoginCalled: false, isPanelOpen: false };
    }
    componentWillMount() {
        const userName = localStorage.getItem('userName');
        const p = this.props;
        if (userName)
            p.setRememberMe(userName);
    }
    componentWillReceiveProps(p) {
        if (p.user && p.user.isAuthenticated) {
            browserHistory.push('/dashboard');
        }
        if (p.rememberUserName) {
            localStorage.setItem('rememberUserName', p.rememberUserName);
            localStorage.setItem('userName', p.userName);
        }
        else {
            localStorage.removeItem('rememberUserName', p.rememberUserName);
            localStorage.removeItem('userName', p.rememberUserName);
        }
    }
    togglePanel = () => {
        this.setState({
            isPanelOpen: !this.state.isPanelOpen
        });
    };
    onShowPassword = () => {
        this.setState({ isShowPassword: !this.state.isShowPassword });
    };
    onLoginClick = () => {
        const p = this.props;
        let validators = [
            ['userName', p => p.userName, "Email or user ID"],
            ['password', p => p.password, "Password"]
        ];
        if (util.validate(validators, p.form, p.formError)) {
            let model = {
                UserName: p.userName,
                Password: p.password
            };
            p.login(model);
            this.setState({ isLoginCalled: true });
        }
    };



    render() {
        const p = this.props;

        let panel = null;
        //Create FAQ header with those OPEN-CLOSE button 

        const header = (
            <div className="faqHeader w100">
                &nbsp; Why create an online profile?
        {!this.state.isPanelOpen ?
                    <span className="openCloseButton">OPEN <i className="fa fa-chevron-down text-orange" /></span>
                    :
                    <span className="openCloseButton">CLOSE <i className="fa fa-chevron-up text-orange" /></span>
                }
            </div>);
        //Add FAQ to the end of steps
        panel = (
            <Panel expanded={this.state.isPanelOpen} collapsible header={header} onSelect={this.togglePanel} className="panel-default step-title">
                <SectionHeader title="Create an online profile for a convenient way to manage your service requests. With an online profile, you can:" />
                <ul>
                    <li type="square">manage your request at any time</li>
                    <li type="square">save time managing multiple service requests</li>
                    <li type="square">save your requests and submit them later</li>
                    <li type="square">add others to receive email notifications</li>
                </ul>
                <p><b>Important:</b> the online profile you create here to track your service request is separate from your <a href="https://accounts.fortisbc.com/" target="_blank">Account Online</a> profile.</p>
            </Panel>);

        return (
            <div className="col-md-6 col-md-offset-3">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <h3 className="panel-title text-primary" style={{ "fontSize": "24px" }}> Log in</h3> <br />
                        <hr className="soften" />
                        <p>Access your service request profile and account information.</p>
                        <div>
                            <TextBox id="userName" name="userName" title="Email or user ID" required />
                            <span className="pull-right">
                                <CheckBox name="rememberUserName" title="Remember me" onClick={this.onRememberMeClick} />
                            </span>
                        </div>
                        <br />
                        <TextBox id="password" name="password" title="Password" isPassword={true} isShowPassword={this.state.isShowPassword} onShowPassword={this.onShowPassword} required />
                        <span className="pull-right"><a onClick={() => browserHistory.push('/forgotpassword')}>Forgot password</a>?</span>
                        <div className="form-group">
                            <div className="row text-center">
                                <div className="col-lg-12" style={{ "display": "inline-flex" }}>
                                    <FortisButton text="LOG IN" onClick={this.onLoginClick} />
                                    <FortisButton onClick={() => browserHistory.push('/register')} text="REGISTER" />
                                </div>
                            </div>
                        </div>
                        {

                            (p.user && p.user.id) && this.state.isLoginCalled ?
                                <div className="form-group">
                                    <span className="control-label has-error" style={{ "color": "#b94a48" }} >
                                        Login failed. Try again.
                                    </span>
                                </div>
                                :
                                null
                        }

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="faqSection">
                                    {panel}
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="form-group">
                            <p>If you don’t have an online profile, you can still <a onClick={() => browserHistory.push('/')}>submit your service request</a>. You’ll have a chance to create one while completing your request.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    userName: PropTypes.string,
    password: PropTypes.string,
    form: PropTypes.object,
    user: PropTypes.object,
    initAPI: PropTypes.func

};

function mapStateToProps(state) {
    return {
        form: state.form,
        userName: state.form.userName,
        password: state.form.password,
        rememberUserName: state.form.rememberUserName,
        user: state.gas.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        initAPI: (model) => {
            dispatch({ type: 'INITIALIZE_LOGIN' });
            dispatch({ type: 'INITIALIZE_API', model });
        },
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        login: (model) => dispatch({ type: 'LOG_IN', model }),
        setRememberMe: (userName) => {
            dispatch({ type: 'checkbox', name: 'rememberUserName', value: "1" });
            dispatch({ type: 'textbox', name: 'userName', value: userName });
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
